export function getRoleBasedRedirect(roles: string[]): string {
  if (roles.includes('admin')) return '/admin';
  if (roles.includes('reviewer')) return '/reviewer/dashboard';
  return '/user';
}
